export const mapboxVersion = 'v3.10.0';

export async function loadMapboxAssets(): Promise<void> {
	await Promise.all(
		[
			loadMapboxJavaScript(),
			loadMapboxStylesheet(),
		]
	);
}

export async function loadMapboxJavaScript(): Promise<void> {
	let didLoad = false;

	return new Promise( ( resolve, reject ) => {
		if ( didLoad ) {
			resolve();

			return;
		}

		didLoad = true;

		const script = document.createElement( 'script' );
		script.src = `https://api.mapbox.com/mapbox-gl-js/${mapboxVersion}/mapbox-gl.js`;

		script.onload = () => {
			return resolve();
		};

		script.onerror = () => {
			return reject( new Error( 'mapbox gl js failed to load' ) );
		};

		script.async = true;

		const first = document.head.getElementsByTagName( 'script' )[0];
		first.parentNode?.insertBefore( script, first );
	} );
}

export async function loadMapboxStylesheet(): Promise<void> {
	let didLoad = false;

	return new Promise( ( resolve, reject ) => {
		if ( didLoad ) {
			resolve();

			return;
		}

		didLoad = true;

		const link = document.createElement( 'link' );
		link.rel = 'stylesheet';
		link.href = `https://api.mapbox.com/mapbox-gl-js/${mapboxVersion}/mapbox-gl.css`;

		link.onload = () => {
			return resolve();
		};

		link.onerror = () => {
			return reject( new Error( 'mapbox gl css failed to load' ) );
		};

		const first = document.head.getElementsByTagName( 'link' )[0];
		first.parentNode?.insertBefore( link, first );
	} );
}
